import { connect } from 'react-redux';
import {
    addFavouriteSecurity,
    fetchSecuritys,
    filterSecurity,
    getAllSecurity,
    getUnselectedAllSecurity,
    handleSecurityRequestClose,
    hideSecurityLoader,
    showSecurityLoader,
    onAddSecurity,
    onAllSecuritySelect,
    onSecurityClose,
    onSecuritySelect,
    onDeleteSecurity,
    onFilterSelectedSecurity,
    onFilterSecurityOptionSelect,
    onSaveSecurity,
    onToggleSecurityDrawer,
    updateSearchSecurity,
} from 'actions/security';

import Component from './component';


export const mapStateToProps = ({ securitys, settings }) => {
    const { width } = settings;
    const {
        loader,
        alertMessage,
        showMessage,
        noContentFoundMessage,
        selectedSectionId,
        drawerState,
        security,
        searchSecurity,
        filterOption,
        allSecurity,
        securityList,
        selectedSecurity,
        selectedSecuritys,
        addSecurityState
    } = securitys;
    return {
        width,
        loader,
        alertMessage,
        showMessage,
        noContentFoundMessage,
        selectedSectionId,
        drawerState,
        security,
        searchSecurity,
        filterOption,
        allSecurity,
        securityList,
        selectedSecurity,
        selectedSecuritys,
        addSecurityState
    };
};
export default connect(mapStateToProps, {
    fetchSecuritys,
    addFavouriteSecurity,
    onSecuritySelect,
    onAddSecurity,
    onSecurityClose,
    onFilterSecurityOptionSelect,
    onSaveSecurity,
    onDeleteSecurity,
    onFilterSelectedSecurity,
    filterSecurity,
    getAllSecurity,
    getUnselectedAllSecurity,
    onAllSecuritySelect,
    updateSearchSecurity,
    onToggleSecurityDrawer,
    handleSecurityRequestClose,
    hideSecurityLoader,
    showSecurityLoader,
})(Component);


// WEBPACK FOOTER //
// ./components/Agile/security/container.js